var _circle, _circle2, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _circle3, _circle4, _ellipse4, _path5, _circle5, _circle6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShibariumDarkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#333333",
    stroke: "#555555",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    fill: "url(#shibaDarkCircleGradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9 C7.5 7.8, 8.2 7, 9.2 7.3 C10 7.6, 9.7 8.8, 9 9.2 Z",
    fill: "#CC5500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 8.8 C8 8.3, 8.5 8.1, 8.8 8.3 C9 8.6, 8.8 9, 8.6 9.1 Z",
    fill: "#DD7722"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9 C16.5 7.8, 15.8 7, 14.8 7.3 C14 7.6, 14.3 8.8, 15 9.2 Z",
    fill: "#CC5500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 8.8 C16 8.3, 15.5 8.1, 15.2 8.3 C15 8.6, 15.2 9, 15.4 9.1 Z",
    fill: "#DD7722"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12.5,
    rx: 5.5,
    ry: 5,
    fill: "url(#faceDarkCircleGradient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 11,
    rx: 0.8,
    ry: 1.2,
    fill: "#1A0E08"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 11,
    rx: 0.8,
    ry: 1.2,
    fill: "#1A0E08"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2,
    cy: 10.6,
    r: 0.25,
    fill: "#DDDDDD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2,
    cy: 10.6,
    r: 0.25,
    fill: "#DDDDDD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 13,
    rx: 0.7,
    ry: 0.5,
    fill: "#1A0E08"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6 C11.2 14.6, 12.8 14.6, 12 13.6",
    fill: "none",
    stroke: "#1A0E08",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 13,
    r: 0.7,
    fill: "#BB6622",
    opacity: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 13,
    r: 0.7,
    fill: "#BB6622",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "shibaDarkCircleGradient",
    cx: "50%",
    cy: "30%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DD8844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#CC5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#AA4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "faceDarkCircleGradient",
    cx: "50%",
    cy: "40%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DDBB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#CC8844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BB6622"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShibariumDarkCircle);
export default __webpack_public_path__ + "static/media/ShibariumDarkCircle.6a5c788d740aa42bba777ee32f863190.svg";
export { ForwardRef as ReactComponent };